<mat-form-field class="fuse-mat-no-subscript w-full">
  <mat-label>{{title}}</mat-label>
  <mat-icon class="icon-size-5" [svgIcon]=icon matPrefix *ngIf="icon"></mat-icon>
  <input type="text" matInput  [(ngModel)]="data" (blur)="sendData($event)">
</mat-form-field>
